import React, { useEffect, useState } from "react";
import "./Header.css";
import { FaClock, FaCalendarAlt, FaRupeeSign } from "react-icons/fa";

const Header = ({ user, toggleSidebar, isSidebarOpen }) => {
  const [time, setTime] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      setTime(
        now.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );

      setDate(
        now.toLocaleDateString([], {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      );
    };

    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <header className={`header ${isSidebarOpen ? "shift" : ""}`}>

      {/* LEFT AREA */}
      <div className="left-area">
        <button className="toggle-btn" onClick={toggleSidebar}>☰</button>

        <div className="time-date">
          <span className="time-box">
            <FaClock /> {time}
          </span>

          <span className="date-box">
            <FaCalendarAlt /> {date}
          </span>
        </div>
      </div>
{/* RIGHT SIDE */}
<div className="right-area">

  {/* USER TYPE BADGE */}
  <div className="user-type">
    {user?.user_type?.toUpperCase() ?? "USER"}
  </div>
  {/* ADD MONEY BUTTON */}
  <a href="/dashboard/add-money" className="addmoney-header-btn">
    Add Money
  </a>
  {/* WALLET */}
  <div className="wallet">
    <FaRupeeSign /> {user?.wallet_balance ?? 0}
  </div>

</div>


    </header>
  );
};

export default Header;
